// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610080309/js/" + chunkId + "." + {"44":"abec582f","225":"616a6eb1","481":"f5341c56","486":"d75ed6b0","770":"b7fc0a67"}[chunkId] + ".0.041920953160188845.chunk.js";
};